import Vue from 'vue'
import Component from 'vue-class-component'
import { tracking, NamedParam } from '@/lib/tracking'

@Component
export class AA extends Vue {
    tracking(trackObj: NamedParam) {
        tracking(trackObj)
    }
}
